import React from "react";
import styled from "styled-components";
import ContactInfo from "./ContactInfo";
import { Divider } from "@material-ui/core";

function RenderEscalation({ claim, index, contact_length }) {
  return (
    <div style={{ display: "flex" }}>
      <ContactContainer key={index}>
        {claim.escalation_region && (
          <ContactInfo label="Region">{claim.escalation_region}</ContactInfo>
        )}
        {claim.escalation_contact_name && (
          <ContactInfo label="Name">
            {claim.escalation_contact_name}
          </ContactInfo>
        )}
        {claim.escalation_contact && (
          <ContactInfo label="Mobile Number" isCopy>
            {claim.escalation_contact}
          </ContactInfo>
        )}
        {claim.escalation_contact_email && (
          <ContactInfo label="Email Address" isCopy>
            {claim.escalation_contact_email}
          </ContactInfo>
        )}
      </ContactContainer>
      <>
        {index !== contact_length - 1 && (
          <Divider
            orientation="vertical"
            style={{ marginRight: "4rem", marginLeft: "4rem" }}
          />
        )}
      </>
    </div>
  );
}

export default RenderEscalation;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
`;
